export const SET_MESSAGE = 'firebaseMessage/setMessage';